import { BrandBenefitsProvider } from '@/components/brand-benefits/BrandBenefitsContext'
import { PromotionsProvider } from '@/components/promotions/PromotionsContext'

type RouteSettingsProvidersProps = {
    pathname: string
    includeBrandBenefits?: boolean
    includePromotions?: boolean
    children: React.ReactNode
}

export const RouteSettingsProviders = ({
    pathname,
    includeBrandBenefits = false,
    includePromotions = false,
    children,
}: RouteSettingsProvidersProps) => {
    let content = children

    if (includePromotions) {
        content = (
            <PromotionsProvider key={pathname}>{content}</PromotionsProvider>
        )
    }

    if (includeBrandBenefits) {
        content = (
            <BrandBenefitsProvider key={pathname}>
                {content}
            </BrandBenefitsProvider>
        )
    }

    return content
}
